var Ce = Object.defineProperty, Me = Object.defineProperties;
var Be = Object.getOwnPropertyDescriptors;
var F = Object.getOwnPropertySymbols;
var ee = Object.prototype.hasOwnProperty, te = Object.prototype.propertyIsEnumerable;
var J = (e, t, n) => t in e ? Ce(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, h = (e, t) => {
  for (var n in t || (t = {}))
    ee.call(t, n) && J(e, n, t[n]);
  if (F)
    for (var n of F(t))
      te.call(t, n) && J(e, n, t[n]);
  return e;
}, w = (e, t) => Me(e, Be(t));
var N = (e, t) => {
  var n = {};
  for (var r in e)
    ee.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && F)
    for (var r of F(e))
      t.indexOf(r) < 0 && te.call(e, r) && (n[r] = e[r]);
  return n;
};
import { jsx as S, Fragment as Re } from "react/jsx-runtime";
import * as s from "react";
import { useState as V, useRef as Te, useEffect as $, forwardRef as L } from "react";
import { O as Ne, g as ke } from "./OptionalPortal-sP4Hf4UO.js";
import { b as xe, d as Ie } from "./get-size-Bc1Pz5yf.js";
import { B as z, c as D } from "./factory-ueRxoNOV.js";
import { a as Le } from "./use-reduced-motion-C9DbPZfj.js";
import { u as Oe } from "./use-id-D2tGiO9x.js";
import { u as Pe } from "./use-window-event-XS3iBc75.js";
import { u as Ae, F as De } from "./FocusTrap-C77tjG9E.js";
import { C as We } from "./CloseButton-BysQSF2E.js";
import { P as _e } from "./Paper-SFv53Ubl.js";
import { T as ie } from "./Transition-esp-rpzm.js";
import { O as Fe } from "./Overlay-ClwECLq6.js";
import { c as je } from "./create-safe-context-DqDyoPVE.js";
var R = function() {
  return R = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, R.apply(this, arguments);
};
function le(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function Xe(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, o; r < a; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Y = "right-scroll-bar-position", H = "width-before-scroll-bar", Ye = "with-scroll-bars-hidden", He = "--removed-body-scroll-bar-size";
function G(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Ve(e, t) {
  var n = V(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var ze = typeof window != "undefined" ? s.useLayoutEffect : s.useEffect, ne = /* @__PURE__ */ new WeakMap();
function Ze(e, t) {
  var n = Ve(null, function(r) {
    return e.forEach(function(a) {
      return G(a, r);
    });
  });
  return ze(function() {
    var r = ne.get(n);
    if (r) {
      var a = new Set(r), o = new Set(e), i = n.current;
      a.forEach(function(c) {
        o.has(c) || G(c, null);
      }), o.forEach(function(c) {
        a.has(c) || G(c, i);
      });
    }
    ne.set(n, e);
  }, [e]), n;
}
function Ge(e) {
  return e;
}
function Ke(e, t) {
  t === void 0 && (t = Ge);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var i = t(o, r);
      return n.push(i), function() {
        n = n.filter(function(c) {
          return c !== i;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(o);
      }
      n = {
        push: function(c) {
          return o(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var i = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(o), i = n;
      }
      var v = function() {
        var d = i;
        i = [], d.forEach(o);
      }, u = function() {
        return Promise.resolve().then(v);
      };
      u(), n = {
        push: function(d) {
          i.push(d), u();
        },
        filter: function(d) {
          return i = i.filter(d), n;
        }
      };
    }
  };
  return a;
}
function Qe(e) {
  e === void 0 && (e = {});
  var t = Ke(null);
  return t.options = R({ async: !0, ssr: !1 }, e), t;
}
var ue = function(e) {
  var t = e.sideCar, n = le(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return s.createElement(r, R({}, n));
};
ue.isSideCarExport = !0;
function Ue(e, t) {
  return e.useMedium(t), ue;
}
var se = Qe(), K = function() {
}, Z = s.forwardRef(function(e, t) {
  var n = s.useRef(null), r = s.useState({
    onScrollCapture: K,
    onWheelCapture: K,
    onTouchMoveCapture: K
  }), a = r[0], o = r[1], i = e.forwardProps, c = e.children, v = e.className, u = e.removeScrollBar, d = e.enabled, m = e.shards, y = e.sideCar, M = e.noRelative, E = e.noIsolation, l = e.inert, f = e.allowPinchZoom, b = e.as, g = b === void 0 ? "div" : b, C = e.gapMode, B = le(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), p = y, x = Ze([n, t]), T = R(R({}, B), a);
  return s.createElement(
    s.Fragment,
    null,
    d && s.createElement(p, { sideCar: se, removeScrollBar: u, shards: m, noRelative: M, noIsolation: E, inert: l, setCallbacks: o, allowPinchZoom: !!f, lockRef: n, gapMode: C }),
    i ? s.cloneElement(s.Children.only(c), R(R({}, T), { ref: x })) : s.createElement(g, R({}, T, { className: v, ref: x }), c)
  );
});
Z.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Z.classNames = {
  fullWidth: H,
  zeroRight: Y
};
var $e = function() {
  if (typeof __webpack_nonce__ != "undefined")
    return __webpack_nonce__;
};
function qe() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = $e();
  return t && e.setAttribute("nonce", t), e;
}
function Je(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function et(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var tt = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = qe()) && (Je(t, n), et(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, nt = function() {
  var e = tt();
  return function(t, n) {
    s.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, de = function() {
  var e = nt(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, rt = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Q = function(e) {
  return parseInt(e || "", 10) || 0;
}, at = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Q(n), Q(r), Q(a)];
}, ot = function(e) {
  if (e === void 0 && (e = "margin"), typeof window == "undefined")
    return rt;
  var t = at(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, ct = de(), A = "data-scroll-locked", it = function(e, t, n, r) {
  var a = e.left, o = e.top, i = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Ye, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(A, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Y, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(H, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(Y, " .").concat(Y, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(H, " .").concat(H, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(A, `] {
    `).concat(He, ": ").concat(c, `px;
  }
`);
}, re = function() {
  var e = parseInt(document.body.getAttribute(A) || "0", 10);
  return isFinite(e) ? e : 0;
}, lt = function() {
  s.useEffect(function() {
    return document.body.setAttribute(A, (re() + 1).toString()), function() {
      var e = re() - 1;
      e <= 0 ? document.body.removeAttribute(A) : document.body.setAttribute(A, e.toString());
    };
  }, []);
}, ut = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r;
  lt();
  var o = s.useMemo(function() {
    return ot(a);
  }, [a]);
  return s.createElement(ct, { styles: it(o, !t, a, n ? "" : "!important") });
}, U = !1;
if (typeof window != "undefined")
  try {
    var j = Object.defineProperty({}, "passive", {
      get: function() {
        return U = !0, !0;
      }
    });
    window.addEventListener("test", j, j), window.removeEventListener("test", j, j);
  } catch (e) {
    U = !1;
  }
var O = U ? { passive: !1 } : !1, st = function(e) {
  return e.tagName === "TEXTAREA";
}, fe = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !st(e) && n[t] === "visible")
  );
}, dt = function(e) {
  return fe(e, "overflowY");
}, ft = function(e) {
  return fe(e, "overflowX");
}, ae = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot != "undefined" && r instanceof ShadowRoot && (r = r.host);
    var a = ve(e, r);
    if (a) {
      var o = me(e, r), i = o[1], c = o[2];
      if (i > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, vt = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, mt = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ve = function(e, t) {
  return e === "v" ? dt(t) : ft(t);
}, me = function(e, t) {
  return e === "v" ? vt(t) : mt(t);
}, ht = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, gt = function(e, t, n, r, a) {
  var o = ht(e, window.getComputedStyle(t).direction), i = o * r, c = n.target, v = t.contains(c), u = !1, d = i > 0, m = 0, y = 0;
  do {
    if (!c)
      break;
    var M = me(e, c), E = M[0], l = M[1], f = M[2], b = l - f - o * E;
    (E || b) && ve(e, c) && (m += b, y += E);
    var g = c.parentNode;
    c = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
  } while (
    // portaled content
    !v && c !== document.body || // self content
    v && (t.contains(c) || t === c)
  );
  return (d && Math.abs(m) < 1 || !d && Math.abs(y) < 1) && (u = !0), u;
}, X = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, oe = function(e) {
  return [e.deltaX, e.deltaY];
}, ce = function(e) {
  return e && "current" in e ? e.current : e;
}, yt = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, pt = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, bt = 0, P = [];
function St(e) {
  var t = s.useRef([]), n = s.useRef([0, 0]), r = s.useRef(), a = s.useState(bt++)[0], o = s.useState(de)[0], i = s.useRef(e);
  s.useEffect(function() {
    i.current = e;
  }, [e]), s.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var l = Xe([e.lockRef.current], (e.shards || []).map(ce), !0).filter(Boolean);
      return l.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), l.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = s.useCallback(function(l, f) {
    if ("touches" in l && l.touches.length === 2 || l.type === "wheel" && l.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = X(l), g = n.current, C = "deltaX" in l ? l.deltaX : g[0] - b[0], B = "deltaY" in l ? l.deltaY : g[1] - b[1], p, x = l.target, T = Math.abs(C) > Math.abs(B) ? "h" : "v";
    if ("touches" in l && T === "h" && x.type === "range")
      return !1;
    var I = ae(T, x);
    if (!I)
      return !0;
    if (I ? p = T : (p = T === "v" ? "h" : "v", I = ae(T, x)), !I)
      return !1;
    if (!r.current && "changedTouches" in l && (C || B) && (r.current = p), !p)
      return !0;
    var _ = r.current || p;
    return gt(_, f, l, _ === "h" ? C : B);
  }, []), v = s.useCallback(function(l) {
    var f = l;
    if (!(!P.length || P[P.length - 1] !== o)) {
      var b = "deltaY" in f ? oe(f) : X(f), g = t.current.filter(function(p) {
        return p.name === f.type && (p.target === f.target || f.target === p.shadowParent) && yt(p.delta, b);
      })[0];
      if (g && g.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!g) {
        var C = (i.current.shards || []).map(ce).filter(Boolean).filter(function(p) {
          return p.contains(f.target);
        }), B = C.length > 0 ? c(f, C[0]) : !i.current.noIsolation;
        B && f.cancelable && f.preventDefault();
      }
    }
  }, []), u = s.useCallback(function(l, f, b, g) {
    var C = { name: l, delta: f, target: b, should: g, shadowParent: wt(b) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(B) {
        return B !== C;
      });
    }, 1);
  }, []), d = s.useCallback(function(l) {
    n.current = X(l), r.current = void 0;
  }, []), m = s.useCallback(function(l) {
    u(l.type, oe(l), l.target, c(l, e.lockRef.current));
  }, []), y = s.useCallback(function(l) {
    u(l.type, X(l), l.target, c(l, e.lockRef.current));
  }, []);
  s.useEffect(function() {
    return P.push(o), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: y
    }), document.addEventListener("wheel", v, O), document.addEventListener("touchmove", v, O), document.addEventListener("touchstart", d, O), function() {
      P = P.filter(function(l) {
        return l !== o;
      }), document.removeEventListener("wheel", v, O), document.removeEventListener("touchmove", v, O), document.removeEventListener("touchstart", d, O);
    };
  }, []);
  var M = e.removeScrollBar, E = e.inert;
  return s.createElement(
    s.Fragment,
    null,
    E ? s.createElement(o, { styles: pt(a) }) : null,
    M ? s.createElement(ut, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function wt(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Et = Ue(se, St);
var he = s.forwardRef(function(e, t) {
  return s.createElement(Z, R({}, e, { ref: t, sideCar: Et }));
});
he.classNames = Z.classNames;
const [Ct, k] = je(
  "ModalBase component was not found in tree"
);
function Mt({ opened: e, transitionDuration: t }) {
  const [n, r] = V(e), a = Te(-1), i = Le() ? 0 : t;
  return $(() => (e ? (r(!0), window.clearTimeout(a.current)) : i === 0 ? r(!1) : a.current = window.setTimeout(() => r(!1), i), () => window.clearTimeout(a.current)), [e, i]), n;
}
function Bt({
  id: e,
  transitionProps: t,
  opened: n,
  trapFocus: r,
  closeOnEscape: a,
  onClose: o,
  returnFocus: i
}) {
  const c = Oe(e), [v, u] = V(!1), [d, m] = V(!1), y = typeof (t == null ? void 0 : t.duration) == "number" ? t == null ? void 0 : t.duration : 200, M = Mt({ opened: n, transitionDuration: y });
  return Pe(
    "keydown",
    (E) => {
      var l;
      E.key === "Escape" && a && !E.isComposing && n && ((l = E.target) == null ? void 0 : l.getAttribute("data-mantine-stop-propagation")) !== "true" && o();
    },
    { capture: !0 }
  ), Ae({ opened: n, shouldReturnFocus: r && i }), {
    _id: c,
    titleMounted: v,
    bodyMounted: d,
    shouldLockScroll: M,
    setTitleMounted: u,
    setBodyMounted: m
  };
}
const Rt = L(
  (T, x) => {
    var I = T, {
      keepMounted: e,
      opened: t,
      onClose: n,
      id: r,
      transitionProps: a,
      onExitTransitionEnd: o,
      onEnterTransitionEnd: i,
      trapFocus: c,
      closeOnEscape: v,
      returnFocus: u,
      closeOnClickOutside: d,
      withinPortal: m,
      portalProps: y,
      lockScroll: M,
      children: E,
      zIndex: l,
      shadow: f,
      padding: b,
      __vars: g,
      unstyled: C,
      removeScrollProps: B
    } = I, p = N(I, [
      "keepMounted",
      "opened",
      "onClose",
      "id",
      "transitionProps",
      "onExitTransitionEnd",
      "onEnterTransitionEnd",
      "trapFocus",
      "closeOnEscape",
      "returnFocus",
      "closeOnClickOutside",
      "withinPortal",
      "portalProps",
      "lockScroll",
      "children",
      "zIndex",
      "shadow",
      "padding",
      "__vars",
      "unstyled",
      "removeScrollProps"
    ]);
    const { _id: _, titleMounted: ge, bodyMounted: ye, shouldLockScroll: pe, setTitleMounted: be, setBodyMounted: Se } = Bt({ id: r, transitionProps: a, opened: t, trapFocus: c, closeOnEscape: v, onClose: n, returnFocus: u }), q = B || {}, { key: we } = q, Ee = N(q, ["key"]);
    return /* @__PURE__ */ S(Ne, w(h({}, y), { withinPortal: m, children: /* @__PURE__ */ S(
      Ct,
      {
        value: {
          opened: t,
          onClose: n,
          closeOnClickOutside: d,
          onExitTransitionEnd: o,
          onEnterTransitionEnd: i,
          transitionProps: w(h({}, a), { keepMounted: e }),
          getTitleId: () => `${_}-title`,
          getBodyId: () => `${_}-body`,
          titleMounted: ge,
          bodyMounted: ye,
          setTitleMounted: be,
          setBodyMounted: Se,
          trapFocus: c,
          closeOnEscape: v,
          zIndex: l,
          unstyled: C
        },
        children: /* @__PURE__ */ S(
          he,
          w(h({
            enabled: pe && M
          }, Ee), {
            children: /* @__PURE__ */ S(
              z,
              w(h({
                ref: x
              }, p), {
                __vars: w(h({}, g), {
                  "--mb-z-index": (l || ke("modal")).toString(),
                  "--mb-shadow": Ie(f),
                  "--mb-padding": xe(b)
                }),
                children: E
              })
            )
          }),
          we
        )
      }
    ) }));
  }
);
Rt.displayName = "@mantine/core/ModalBase";
function Tt() {
  const e = k();
  return $(() => (e.setBodyMounted(!0), () => e.setBodyMounted(!1)), []), e.getBodyId();
}
var W = { title: "m_615af6c9", header: "m_b5489c3c", inner: "m_60c222c7", content: "m_fd1ab0aa", close: "m_606cb269", body: "m_5df29311" };
const Nt = L(
  (r, n) => {
    var a = r, { className: e } = a, t = N(a, ["className"]);
    const o = Tt(), i = k();
    return /* @__PURE__ */ S(
      z,
      w(h({
        ref: n
      }, t), {
        id: o,
        className: D({ [W.body]: !i.unstyled }, e)
      })
    );
  }
);
Nt.displayName = "@mantine/core/ModalBaseBody";
const kt = L(
  (a, r) => {
    var o = a, { className: e, onClick: t } = o, n = N(o, ["className", "onClick"]);
    const i = k();
    return /* @__PURE__ */ S(
      We,
      w(h({
        ref: r
      }, n), {
        onClick: (c) => {
          i.onClose(), t == null || t(c);
        },
        className: D({ [W.close]: !i.unstyled }, e),
        unstyled: i.unstyled
      })
    );
  }
);
kt.displayName = "@mantine/core/ModalBaseCloseButton";
const xt = L(
  (c, i) => {
    var v = c, { transitionProps: e, className: t, innerProps: n, onKeyDown: r, style: a } = v, o = N(v, ["transitionProps", "className", "innerProps", "onKeyDown", "style"]);
    const u = k();
    return /* @__PURE__ */ S(
      ie,
      w(h(w(h({
        mounted: u.opened,
        transition: "pop"
      }, u.transitionProps), {
        onExited: () => {
          var d, m, y;
          (d = u.onExitTransitionEnd) == null || d.call(u), (y = (m = u.transitionProps) == null ? void 0 : m.onExited) == null || y.call(m);
        },
        onEntered: () => {
          var d, m, y;
          (d = u.onEnterTransitionEnd) == null || d.call(u), (y = (m = u.transitionProps) == null ? void 0 : m.onEntered) == null || y.call(m);
        }
      }), e), {
        children: (d) => /* @__PURE__ */ S(
          "div",
          w(h({}, n), {
            className: D({ [W.inner]: !u.unstyled }, n.className),
            children: /* @__PURE__ */ S(De, { active: u.opened && u.trapFocus, innerRef: i, children: /* @__PURE__ */ S(
              _e,
              w(h({}, o), {
                component: "section",
                role: "dialog",
                tabIndex: -1,
                "aria-modal": !0,
                "aria-describedby": u.bodyMounted ? u.getBodyId() : void 0,
                "aria-labelledby": u.titleMounted ? u.getTitleId() : void 0,
                style: [a, d],
                className: D({ [W.content]: !u.unstyled }, t),
                unstyled: u.unstyled,
                children: o.children
              })
            ) })
          })
        )
      })
    );
  }
);
xt.displayName = "@mantine/core/ModalBaseContent";
const It = L(
  (r, n) => {
    var a = r, { className: e } = a, t = N(a, ["className"]);
    const o = k();
    return /* @__PURE__ */ S(
      z,
      h({
        component: "header",
        ref: n,
        className: D({ [W.header]: !o.unstyled }, e)
      }, t)
    );
  }
);
It.displayName = "@mantine/core/ModalBaseHeader";
const Lt = {
  duration: 200,
  timingFunction: "ease",
  transition: "fade"
};
function Ot(e) {
  const t = k();
  return h(h(h({}, Lt), t.transitionProps), e);
}
const Pt = L(
  (i, o) => {
    var c = i, { onClick: e, transitionProps: t, style: n, visible: r } = c, a = N(c, ["onClick", "transitionProps", "style", "visible"]);
    const v = k(), u = Ot(t);
    return /* @__PURE__ */ S(
      ie,
      w(h({
        mounted: r !== void 0 ? r : v.opened
      }, u), {
        transition: "fade",
        children: (d) => /* @__PURE__ */ S(
          Fe,
          h({
            ref: o,
            fixed: !0,
            style: [n, d],
            zIndex: v.zIndex,
            unstyled: v.unstyled,
            onClick: (m) => {
              e == null || e(m), v.closeOnClickOutside && v.onClose();
            }
          }, a)
        )
      })
    );
  }
);
Pt.displayName = "@mantine/core/ModalBaseOverlay";
function At() {
  const e = k();
  return $(() => (e.setTitleMounted(!0), () => e.setTitleMounted(!1)), []), e.getTitleId();
}
const Dt = L(
  (r, n) => {
    var a = r, { className: e } = a, t = N(a, ["className"]);
    const o = At(), i = k();
    return /* @__PURE__ */ S(
      z,
      w(h({
        component: "h2",
        ref: n,
        className: D({ [W.title]: !i.unstyled }, e)
      }, t), {
        id: o
      })
    );
  }
);
Dt.displayName = "@mantine/core/ModalBaseTitle";
function qt({ children: e }) {
  return /* @__PURE__ */ S(Re, { children: e });
}
export {
  Nt as M,
  qt as N,
  kt as a,
  xt as b,
  It as c,
  Pt as d,
  Rt as e,
  Dt as f
};
